<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-table
          v-if="$store.state.roles.some(v=>['admin','salemanager', 'user_sell'].includes(v))"
          :data="allTargets"
          wrap-cells
          :hide-header="$q.screen.lt.md || dashboardView"
          :pagination="pagination"
          flat>
        <template v-slot:header class="text-subtitle2" v-if="!dashboardView">
          <td class="text-center">تاریخ شروع</td>
          <td class="text-center">تاریخ پایان</td>
          <td class="text-center"> عنوان هدف</td>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" :class="props.row.MasterID?'bg-grey-3 shadow-4':''" v-if="!$q.screen.lt.md">
            <td style="width: 120px" v-if="!dashboardView || isArchived">
              <q-chip v-if="props.row.MasterID || isArchived" color="deep-orange" icon="event"
                      :label="props.row.startDate" square
                      outline/>
            </td>
            <td style="width: 120px" v-if="!dashboardView || isArchived">
              <q-chip v-if="props.row.MasterID || isArchived" color="deep-orange" icon="event"
                      :label="props.row.endDate" square
                      outline/>
            </td>
            <td :class="props.row.MasterID?'text-bold':''">
              {{ props.row.description }}
              <q-space/>
              <q-chip size="sm" text-color="white" label="هدف کالایی" color="green" icon="tag"
                      v-if="JSON.parse(JSON.stringify(props.row.goods)).length>0"/>
              <q-chip size="sm" text-color="white" label="هدف گروه کالایی" color="green" icon="tag"
                      v-if="JSON.parse(JSON.stringify(props.row.goodsGroup)).length>0
                      && JSON.parse(JSON.stringify(props.row.goods)).length===0"/>
              <q-chip size="sm" text-color="white" label="هدف معرف" color="green" icon="tag"
                      v-if="props.row.PresenterCommision
                      && props.row.PresenterCommision>0"/>
              <q-space/>
              <q-chip size="sm" square icon="support_agent" :label="JSON.parse(JSON.stringify(props.row.employees))[0].UserName"
              v-if="props.row.employees && JSON.parse(JSON.stringify(props.row.employees)).length===1"/>

            </td>
            <td style="width: 120px">
              <q-btn flat round icon="visibility" @click="showTargetAudit(props.row)" color="indigo" v-if="false"/>
              <q-btn flat round icon="visibility" @click="editTarget(props.row)" color="indigo" v-if="dashboardView"/>
              <q-btn flat round v-if="$store.state.roles.some(v=>['admin','salemanager'].includes(v)) && !viewOnly"
                     icon="edit" @click="editTarget(props.row)" color="blue"/>
              <q-btn flat class="q-ml-xs" round v-if="$store.state.roles.some(v=>['admin','salemanager'].includes(v))
              && !viewOnly && ((allTargets.filter(rec=> !rec.MasterID).length>0 && !props.row.MasterID) ||
              ((allTargets.filter(rec=> !rec.MasterID).length===0 && props.row.MasterID)))"
                     icon="remove" @click="removeTarget(props)" color="red"/>
            </td>
          </q-tr>
          <q-tr :props="props" :class="props.row.MasterID?'bg-grey-3 shadow-4':''" v-if="$q.screen.lt.md">
            <q-td>
              <q-card flat :class="props.row.MasterID?'bg-grey-3 shadow-4':''">
                <q-card-section class="no-padding">
                  <q-chip v-if="props.row.MasterID" color="deep-orange" icon="event" :label="props.row.startDate" square
                          outline/>
                  <q-chip v-if="props.row.MasterID" color="deep-orange" icon="event" :label="props.row.endDate" square
                          outline/>
                  <q-separator v-if="props.row.MasterID"/>
                  <span :class="props.row.MasterID?'text-bold text-right':''">
                    {{ props.row.description }}
                    <q-space/>
                     <q-chip size="sm" text-color="white" label="هدف کالایی" color="green" icon="tag"
                             v-if="JSON.parse(JSON.stringify(props.row.goods)).length>0"/>

                  </span>
                </q-card-section>
                <q-card-actions align="left" class="no-padding">
                  <q-btn flat round icon="visibility" @click="showTargetAudit(props.row)" color="indigo" v-if="false"/>
                  <q-btn flat round v-if="$store.state.roles.some(v=>['admin','salemanager'].includes(v)) && !viewOnly"
                         icon="edit" @click="editTarget(props.row)" color="blue"/>
                  <q-btn flat round v-if="$store.state.roles.some(v=>['admin','salemanager'].includes(v))
              && !viewOnly && ((allTargets.filter(rec=> !rec.MasterID).length>0 && !props.row.MasterID) ||
              ((allTargets.filter(rec=> !rec.MasterID).length===0 && props.row.MasterID)))"
                         icon="remove" @click="removeTarget(props)" color="red"/>
                  <q-btn round icon="visibility" @click="editTarget(props.row)" color="indigo" v-if="dashboardView"/>
                </q-card-actions>
              </q-card>
            </q-td>
          </q-tr>
        </template>
      </q-table>

    </q-card-section>

    <q-dialog v-model="targetResultDialog"
              :maximized="$q.screen.lt.md">
      <AuditTarget :audit-info="auditInfo" :audit-result="auditResult" :sale-ord="sale_ord" :visit-log="visit_log"
                   :customer-log="customer_log" :employees="employees" :sale-price-by-user="salePriceByUser"/>
    </q-dialog>
  </q-card>
</template>

<script>
import AuditTarget from "@/components/SaleTargets/AuditTarget";
import {mapActions} from "vuex";

export default {
  name: "AuditTargetList",
  props: ['allTargets', 'viewOnly', 'dashboardView', 'isArchived'],
  components: {AuditTarget},
  data() {
    return {
      pagination: {
        rowsPerPage: 15
      },
      auditInfo: '',
      targetResultDialog: false,
      auditResult: '',
      sale_ord: [],
      visit_log: [],
      customer_log: [],
      employees: [],
      salePriceByUser: []
    }
  },
  methods: {
    ...mapActions({
      getTargetAuditReport: 'Dashboard/getTargetAuditReport'
    }),
    showTargetAudit(rowInfo) {
      this.auditResult = ''
      this.getTargetAuditReport(rowInfo.id).then((res) => {
        this.customer_log = JSON.parse(res.customer_log)
        this.auditInfo = rowInfo
        this.sale_ord = JSON.parse(res.sale_ord);
        if (res.employees !== undefined && res.employees !== 'None') {
          this.employees = eval(res.employess);
        } else {
          this.employees = [];
        }
        this.visit_log = JSON.parse(res.visit_log);
        if (JSON.parse(res.audit_results).length > 0) {
          this.auditResult = JSON.parse(res.audit_results)[0]
        } else {
          this.auditResult = {}
        }
        this.auditResult.realSaleCountProgress = 0
        this.auditResult.realVisitCountProgress = 0
        this.auditResult.realCustomerCountProgress = 0
        this.auditResult.RealSaleCount = this.auditResult.RealSaleCount === undefined ? 0 : this.auditResult.RealSaleCount
        this.auditResult.RealVisit_Count = this.auditResult.RealVisit_Count === undefined ? 0 : this.auditResult.RealVisit_Count
        this.auditResult.RealCustomerCount = this.auditResult.RealCustomerCount === undefined ? 0 : this.auditResult.RealCustomerCount

        if (this.auditResult) {
          this.auditResult.realSaleCountProgress = this.auditResult.RealSaleCount === 0 || this.auditInfo.saleCount === 0
              ? 0 : (((this.auditResult.RealSaleCount) / this.auditInfo.saleCount) * 100).toFixed(2)
          this.auditResult.realVisitCountProgress = this.auditResult.RealVisit_Count === 0 || this.auditInfo.visitCustomer === 0 ? 0
              : (((this.auditResult.RealVisit_Count) / this.auditInfo.visitCustomer) * 100).toFixed(2)
          this.auditResult.realCustomerCountProgress = this.auditResult.RealCustomerCount === 0 || this.auditInfo.newCustomer === 0
              ? 0 : (((this.auditResult.RealCustomerCount) / this.auditInfo.newCustomer) * 100).toFixed(2)
        }
        this.auditResult.telCount = res.tel_count
        this.auditInfo.callCustomer = !this.auditInfo.callCustomer ? 0 : this.auditInfo.callCustomer

        this.auditInfo.salePrice = res.salePrice
        this.auditInfo.salePriceProgress = res.salePriceProgress
        this.salePriceByUser = eval(res.salePriceByUser)
        this.targetResultDialog = true
      })
    },
    editTarget(rowInfo) {
      this.$emit('edit-target', rowInfo)
    },
    removeTarget(rowInfo) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'از حذف هدف اطمینان دارید؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.$emit('remove-target', rowInfo)
      })
    }
  }
}
</script>

<style scoped>

</style>
